class LouiseSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.index = 0;
    this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.controller = new AbortController();
    const opts = { signal: this.controller.signal };
    this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1), opts);
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1), opts);
    this.querySelector('[data-pause]')?.addEventListener('click', (event) => {
      this.paused = !this.paused;
      event.currentTarget.textContent = this.paused ? '▶' : 'Ⅱ';
      event.currentTarget.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
    }, opts);
    if (this.slides.length > 1 && this.dataset.autoplay === 'true') {
      this.timer = setInterval(() => {
        if (!this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.show(this.index + 1);
      }, Number(this.dataset.speed) || 7000);
    }
    document.addEventListener('shopify:block:select', (event) => {
      const index = this.slides.findIndex(slide => slide.contains(event.target));
      if (index >= 0) { this.paused = true; this.show(index); }
    }, opts);
  }
  show(index) {
    if (!this.slides.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
  }
  disconnectedCallback() { clearInterval(this.timer); this.controller?.abort(); }
}
customElements.define('ld-slideshow', LouiseSlideshow);

const louiseRecentKey = 'louise-dublin-recent-products';
const louiseProductPath = document.body.dataset.ldProductUrl;
const louiseSafeProductPath = path => typeof path === 'string' && /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/[a-z0-9_-]+$/i.test(path);
function louiseReadRecent() {
  try {
    const value = JSON.parse(localStorage.getItem(louiseRecentKey) || '[]');
    return Array.isArray(value) ? value.filter(louiseSafeProductPath).slice(0, 20) : [];
  } catch { return []; }
}
if (louiseSafeProductPath(louiseProductPath)) {
  try { localStorage.setItem(louiseRecentKey, JSON.stringify([louiseProductPath, ...louiseReadRecent().filter(path => path !== louiseProductPath)].slice(0, 20))); } catch { /* Storage may be disabled. */ }
}
class LouiseRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const paths = louiseReadRecent().filter(path => path !== louiseProductPath).slice(0, Number(this.dataset.limit) || 5);
    if (!paths.length) return;
    this.controller = new AbortController();
    const cards = await Promise.all(paths.map(async path => {
      try {
        const response = await fetch(path + '?section_id=ld-recent-card', { signal: this.controller.signal });
        if (!response.ok) return null;
        const dom = new DOMParser().parseFromString(await response.text(), 'text/html');
        return dom.querySelector('[data-ld-recent-card]');
      } catch { return null; }
    }));
    if (!this.isConnected) return;
    const grid = this.querySelector('[data-recent-products]');
    cards.filter(Boolean).forEach(card => grid.append(card));
    this.hidden = !grid.children.length;
  }
  disconnectedCallback() { this.controller?.abort(); }
}
customElements.define('ld-recently-viewed', LouiseRecentlyViewed);

// Labelled inventory fixtures are restricted to Shopify theme previews.
(function louisePreviewStock() {
  if (!window.Shopify?.designMode && !(window.location?.hostname || '').endsWith('.shopifypreview.com')) return;
  const counts = new Map();
  const rendered = new WeakSet();
  function update(root) {
    const nodes = [];
    if (root.matches?.('[data-ld-test-stock]')) nodes.push(root);
    root.querySelectorAll?.('[data-ld-test-stock]').forEach(node => nodes.push(node));
    nodes.forEach(node => {
      if (rendered.has(node)) return;
      rendered.add(node);
      const variant = node.dataset.variant;
      if (!counts.has(variant)) counts.set(variant, Math.floor(Math.random() * 5) + 1);
      node.textContent = counts.get(variant);
    });
  }
  update(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) update(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
})();
